import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { Slide, IconButton } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import './index.css';
import App from './App';
import { initNativeApp } from './lib/nativeApp';
import { initNativeDownloads } from './lib/nativeDownload';
import { initNativePush } from './lib/nativePush';
import reportWebVitals from './reportWebVitals';
import { applyMiddleware, createStore } from 'redux';
import { Provider } from 'react-redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import rootReducer, { rootSaga } from './modules';
import { tempSetUser } from './modules/auth';
import CloseIcon from '@mui/icons-material/Close';
import theme from './theme';
import dayjs from 'dayjs';
import isLeapYear from 'dayjs/plugin/isLeapYear'; // 윤년 판단 플러그인
import 'dayjs/locale/ko'; // 한국어 가져오기

dayjs.extend(isLeapYear); // 플러그인 등록
dayjs.locale('ko'); // 언어 등록

const sagaMiddleware = createSagaMiddleware();

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(sagaMiddleware)),
);

export default store;


function loadUser() {
  try {
    const user = localStorage.getItem('user');
    if (!user) return; //로그인 상태가 아니라면 아무것도 안함.

    store.dispatch(tempSetUser(JSON.parse(user)));
  } catch (e) {
    console.log('localStorage is not working');
  }
}

sagaMiddleware.run(rootSaga);
loadUser();
initNativeApp(); // Android 래퍼(Capacitor)에서만 동작, 웹에서는 no-op
initNativeDownloads(); // 다운로드(blob/data anchor, window.open) 가로채기 - 역시 네이티브 전용
initNativePush(); // 폰 푸시(FCM) 권한/토큰 등록 - 역시 네이티브 전용

// add action to all snackbars
const notistackRef = React.createRef();
const onClickDismiss = (key) => () => {
  notistackRef.current.closeSnackbar(key);
};

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <BrowserRouter>
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          TransitionComponent={Slide}
          ref={notistackRef}
          action={(key) => (
            <React.Fragment>
              <IconButton
                aria-label="close"
                color="inherit"
                sx={{ p: 0.5 }}
                onClick={onClickDismiss(key)}
              >
                <CloseIcon />
              </IconButton>
            </React.Fragment>
          )}
        >
          <App />
        </SnackbarProvider>
      </BrowserRouter>
    </Provider>
  </ThemeProvider>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
